import { useEffect, useState } from 'react';
import { useFetch } from "../../../../hooks/useFetch";
import { payloadDateFormat } from "../../../../utils/helper";
import AppointmentList from "../../../AppointmentList/AppointmentList";
import SidebarFilterMenu from "../../../SidebarFilterMenu/SidebarFilterMenu";
import { useStore } from '../../../../GlobalProvider/GlobalProvider';
import { useSelector } from 'react-redux';
import { BsFilterSquare } from 'react-icons/bs';
import { CiSquarePlus } from 'react-icons/ci';
import { InputText } from 'primereact/inputtext';
import { useNavigate } from 'react-router-dom';

const WaitingRoom = () => {
    const { selectedStatus, setSelectedStatus, search, setSearch, fromDate, setFromDate, toDate, setToDate } = useStore();
    const [appointmentData, setAppointmentData] = useState<any[]>([]);
    const [update, setUpdate] = useState<boolean>(false);
    const [limitData] = useState<number>(10);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [totalPages, setTotalPages] = useState<number>(1);
    const [total, setTotal] = useState<number>(0);
    const [showFilter, setShowFilter] = useState<boolean>(false);
    const { selectedRole, selectedDoctor } = useSelector((state: any) => state.auth);
    const navigate = useNavigate();

    const { data: appointments, loading, notFound } = useFetch(
        `/appointment/list?doctorId=${selectedDoctor?._id}&userRoleId=${selectedRole?._id}&per_page=${limitData}&current_page=${currentPage}${search ? `&search=${search}` : ""}${selectedStatus ? `&status=${selectedStatus}` : ""}${fromDate && toDate ? `&startDate=${payloadDateFormat(fromDate)}` : ""}${fromDate && toDate ? `&endDate=${payloadDateFormat(toDate)}` : ""}`,
        [update]
    );

    useEffect(() => {
        if (notFound) { setAppointmentData([]); setTotal(0); }
        if (appointments) {
            setAppointmentData(appointments?.appointments);
            setTotal(appointments?.total || 0);
            setTotalPages(Math.ceil(appointments?.total / limitData));
        }
    }, [appointments, notFound, limitData]);

    const handlePageChange = (page: number) => {
        setCurrentPage(page);
        setUpdate(!update);
    };

    return (
        <div>
            {/* Compact toolbar: filter + search + new */}
            <div className="flex items-center gap-2 mb-3">
                <button
                    aria-label="Filters"
                    className="flex-shrink-0 p-2.5 rounded-xl border border-gray-200 bg-white shadow-sm active:bg-gray-50"
                    onClick={() => setShowFilter(true)}
                >
                    <BsFilterSquare className="text-[#12AB81]" size={19} />
                </button>
                <InputText
                    value={search}
                    placeholder="Search patients..."
                    className="flex-1 p-2.5 border border-gray-200 rounded-xl text-sm bg-white shadow-sm focus:outline-none"
                    onChange={(e) => { setSearch(e.target.value); setCurrentPage(1); }}
                />
                <button
                    aria-label="New appointment"
                    onClick={() => navigate('/create-appointment')}
                    className="flex-shrink-0 flex items-center gap-1.5 px-3 py-2.5 bg-[#12AB81] text-white rounded-xl text-xs font-semibold shadow-sm active:opacity-80"
                >
                    <CiSquarePlus size={17} />
                    New
                </button>
            </div>

            <AppointmentList
                appointmentData={appointmentData}
                loading={loading}
                update={update}
                setUpdate={setUpdate}
                totalPages={totalPages}
                handlePageChange={handlePageChange}
                currentPage={currentPage}
                total={total}
            />
            <SidebarFilterMenu
                showFilter={showFilter}
                setShowFilter={setShowFilter}
                setFromDate={setFromDate}
                setToDate={setToDate}
                fromDate={fromDate}
                toDate={toDate}
                selectedStatus={selectedStatus}
                setSelectedStatus={setSelectedStatus}
                isStatus={true}
            />
        </div>
    );
};

export default WaitingRoom;
